export const NAME = 'CONSULTATION_SERVICE';

export const getConsultationServiceBookings = (store) =>
  store[NAME].serviceBookings || [];
